module.exports = __webpack_public_path__ + "static/Agne_Jasinaviciute_Trakimiene-d76b99388c307cad9174d3332c5006c2.jpg";